<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 16 18"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M13.601 4.408c-.265-.265-.694-.265-.959 0-.264.265-.264.694 0 .959 1.244 1.244 1.93 2.898 1.93 4.657 0 1.76-.686 3.414-1.93 4.658-1.284 1.284-2.97 1.926-4.656 1.926-1.687 0-3.374-.643-4.658-1.927-2.568-2.567-2.568-6.745 0-9.313.265-.265.265-.694 0-.96-.265-.264-.694-.264-.959 0-3.096 3.097-3.096 8.136 0 11.232 1.549 1.549 3.582 2.323 5.617 2.323 2.033 0 4.067-.774 5.615-2.322 1.5-1.5 2.327-3.495 2.327-5.617 0-2.121-.827-4.116-2.327-5.616z"
        transform="translate(-1385 -24) translate(1385 24)"
      />
      <path
        d="M7.985 8.783c.374 0 .678-.303.678-.678V.678C8.663.304 8.359 0 7.985 0c-.375 0-.678.304-.678.678v7.427c0 .375.303.678.678.678z"
        transform="translate(-1385 -24) translate(1385 24)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-button-power",
  components: {},
})
export class IconButtonPower extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconButtonPower;
</script>
